module.exports = __webpack_public_path__ + "static/img/Ember_Logo.e765e2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ember_Logo.png
// module id = Z5B0
// module chunks = 0